import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useIsClient } from "@/hooks/useIsClient";
import { queryClient } from "utilities/queryClient";

// The devtools alter their container markup during render, which makes the
// SSR'd HTML differ from the first client render and fails hydration in
// development. Rendering client-only keeps both renders identical.
const QueryDevtools = () => {
  const isClient = useIsClient();

  return isClient ? <ReactQueryDevtools initialIsOpen={false} /> : null;
};

export const wrapApp = ({ element }: { element: React.ReactNode }) => (
  <QueryClientProvider client={queryClient}>
    {element}
    <QueryDevtools />
  </QueryClientProvider>
);
